import { Object3D } from 'three'
import { mapMutations } from 'vuex'

const Object3DMixin = {
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  inject: ['three'],
  created () {
    const object = new Object3D()
    object.name = this.node.id
    object.userData.root = true
    this.object3d = object
    this.three.scene.add(object)
    this.attachObject({ node: this.node, object })

    this.setPosition()
    this.setScale()
    this.setRotation()
  },
  beforeDestroy () {
    this.three.scene.remove(this.object3d)
  },
  methods: {
    ...mapMutations('three', ['attachObject']),
    setPosition () {
      if (this.node.position) {
        this.object3d.position.x = this.node.position.x
        this.object3d.position.y = this.node.position.y
        this.object3d.position.z = this.node.position.z
      }
    },
    setScale () {
      if (this.node.scale) {
        this.object3d.scale.set(
          this.node.scale.x,
          this.node.scale.y,
          this.node.scale.z
        )
      }
    },
    setRotation () {
      // We should only set the rotation when it exists on the node
      // Adittionaly sometimes the rotation values get saved as _x _y _z instead
      // of x,y,z. I'm not sure why this is but the time being we can just work around
      // it by checking which properties exist
      if (this.node.rotation && this.node.rotation.x) {
        this.object3d.rotation.x = this.node.rotation.x
        this.object3d.rotation.y = this.node.rotation.y
        this.object3d.rotation.z = this.node.rotation.z
      } else if (this.node.rotation && this.node.rotation._x) {
        this.object3d.rotation.x = this.node.rotation._x
        this.object3d.rotation.y = this.node.rotation._y
        this.object3d.rotation.z = this.node.rotation._z
      }
    }
  }
}

export default Object3DMixin
